export default function detectarDispositivoMovel() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Expressões regulares para detecção de dispositivos móveis comuns
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
}
